module.exports = __webpack_public_path__ + "static/title-light-38ddd5f435e4d34dc11a9a5e74d53598.png";